exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filters[data-v-576a6c3b] { margin-bottom: 4px;\n}.pagination[data-v-576a6c3b] { text-align: right; margin-top: 18px;\n}", ""]);

// exports
